import { useState, useEffect } from "react";
import * as FeatherIcon from 'react-feather';

// ----------------------------
// Geography Component
// ----------------------------
const Geography = ({ onNext, onPrev, updateData, data }) => {
    const regions = [
      "North America",
      "Latin America",
      "Europe",
      "Middle East",
      "Asia Pacific",
      "Africa"
    ];
    const [selected, setSelected] = useState(data.geographies || []);
    const [notes, setNotes] = useState(data.geographyNotes || "");
  
    useEffect(() => {
      updateData({ geographies: selected, geographyNotes: notes });
    }, [selected, notes]);
  
    const toggleRegion = (region) => {
      setSelected((prev) =>
        prev.includes(region) ? prev.filter((r) => r !== region) : [...prev, region]
      );
    };
  
    return (
      <div className="wizard_three">
        <h5 className="custom_lable mb-3">Key Geographic Markets</h5>
        <div className="row">
          {regions.map((region, idx) => (
            <div className="col-6" key={idx}>
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input "
                  id={`geo-${idx}`}
                  checked={selected.includes(region)}
                  onChange={() => toggleRegion(region)}
                />
                <label className="form-check-label custom_checkbox_lable" htmlFor={`geo-${idx}`}>{region}</label>
              </div>
            </div>
          ))}
        </div>
  
        <h5 className="mt-4 custom_lable">Market Maturity Considerations</h5>
        <textarea
          className="form-control custom_input_textarea"
          placeholder="Describe any specific geographic considerations, regulatory environments, or market maturity factors..."
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        ></textarea>
  
        <div className="mt-4">
          <button className="btn btn-secondary me-2 previous_btn_wz" onClick={onPrev}><FeatherIcon.ChevronLeft className='prev_feather'/> Previous</button>
          <button className="btn btn-primary next_btn_wz" onClick={onNext}>Next <FeatherIcon.ChevronRight className='next_feather'/> </button>
        </div>
      </div>
    );
  };

  export default Geography;